import wrapInContainerStyles from "@insite/client-framework/Common/wrapInContainerStyles";
import { TYPOGRAPHY } from "@tSurya/theme/design";
import { customTextBadgeStyles } from "@tSurya/Widgets/ProductDetails/SurCustomProductDetailsTextBadge";
import { css } from "styled-components";

customTextBadgeStyles.badgeText = {
    css: css`
    align-items: center;
    justify-content: center;
    font-style: normal;
    font-weight: ${TYPOGRAPHY.weight.bold} !important;
    font-size: ${TYPOGRAPHY.size.smallest} !important;
    line-height: ${TYPOGRAPHY.lineHeight.base}!important;
    width: 100%;
    white-space: nowrap;
    ${wrapInContainerStyles}
`,
}